import {
  ChangeDetectorRef,
  ComponentFactoryResolver,
  Directive,
  ElementRef,
  Inject,
  Injector,
  Input,
  OnChanges,
  OnInit,
  Renderer2,
  SimpleChanges,
} from '@angular/core';
import { LoadingComponent } from '../../components/loads/loading/loading.component';
import { MAT_FORM_FIELD, MatFormField } from '@angular/material/form-field';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { RequiredInput, Warning } from '../../../../utils/models/input.interface';

@Directive({
  selector: '[warningInputInduxtry]',
})
export class WarningInputInduxtryDirective implements OnInit, OnChanges {
  @Input() styleWarning: string
  @Input() warning: Warning;
  @Input() required: RequiredInput;
  @Input() textRequired: string
  private _unsubscribeAll$ = new Subject<void>();

  constructor(
    public el: ElementRef,
    private renderer: Renderer2,
    private resolver: ComponentFactoryResolver,
    private injector: Injector,
    private cdr: ChangeDetectorRef,
    @Inject(MAT_FORM_FIELD) private readonly mat: MatFormField
  ) {}

  ngOnInit(): void {
    this.initializeWarning();
    setTimeout(() => {
      this.createWarning();
    }, 100)

    if (this.mat._control?.stateChanges && this.required?.active === true) {
      this.mat._control?.stateChanges.pipe(takeUntil(this._unsubscribeAll$)).subscribe(() => {
        if(this.mat._control?.ngControl?.control?.status === 'INVALID' && !this.mat._control?.ngControl?.control?.pristine){
          this.warning.status = 'error';
          this.warning.text = this.required.text
          this.createWarning()
        } else {
          this.warning.status = '';
          this.warning.text = ''
          this.createWarning()
        }
      })
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes?.warning?.firstChange === false) {
      this.createWarning()
    }
  }

  initializeWarning(): void {
    if (!this.warning) {
      this.warning = { status: '', text: '', textPosition: '' };
    } else {
      this.warning.status = this.warning.status || '';
      this.warning.text = this.warning.text || '';
      this.warning.textPosition = this.warning.textPosition || '';
    }

    if (!this.required) {
      this.required = {
        active: false,
        text: '',
        textPosition: ''
      };
    } else {
      this.required.active = this.required.active ?? false;
      this.required.text = this.required.text ?? '';
      this.required.textPosition = this.required.textPosition ?? '';
    }
  }



  createWarning() {
    const nativeElement: HTMLElement = this.el.nativeElement;

    // Remover elementos antigos
    this.removeOldElements(nativeElement);

    //Elementos que vão ser utilizados
    const containerIconSelect = nativeElement.getElementsByClassName('mat-select-value');

    let containerIcon: any

    if(containerIconSelect.length >0){
      containerIcon = nativeElement.getElementsByClassName(
        'mat-select-value'
      );
    } else {
      containerIcon = nativeElement.getElementsByClassName(
      'mat-form-field-infix'
     );
    }
    const containerBorder = nativeElement.getElementsByClassName(
      'mat-form-field-outline'
    );
    const containerText = nativeElement.getElementsByClassName(
      'mat-form-field-subscript-wrapper'
    );


    if (containerIcon?.length > 0 && containerText?.length > 0 && containerBorder?.length > 0) {
      let firstItemIcon = containerIcon.item(0) as HTMLElement;
      let firstItemText = containerText.item(0) as HTMLElement;
      let firstItemBorder = containerBorder.item(0) as HTMLElement;

      //Criar Ícone
      const imgElement = document.createElement('img');
      imgElement.setAttribute('class', 'dynamic-icon');
      if(containerIconSelect.length > 0){
        imgElement.setAttribute(
          'style',
          this.styleWarning ? this.styleWarning :
          `z-index: 2; width: 16px; height: 16px; margin-right:10px; align-self: center; position: relative; top: -5px; background-color: #FFFFFF`
        );
      } else {
        imgElement.setAttribute(
          'style',
          this.styleWarning ? this.styleWarning :
          `z-index: 2; width: 16px; height: 16px; margin-right:10px; align-self: center; background-color: #FFFFFF`
        );
      }

      //Criar Texto
      const textElement = document.createElement('p');
      textElement.setAttribute('class', 'dynamic-text');
      textElement.setAttribute('style', `text-align: ${this.required?.textPosition !== '' ? this.required?.textPosition : this.warning?.textPosition !== '' ? this.warning?.textPosition : 'right'}; margin-top: 10px; font-size: 12px;`);
      textElement.textContent = this.warning?.text;
      const isTextActive = this.warning?.text === '' || this.warning?.text === null || this.warning?.text === undefined;

      if (firstItemIcon && firstItemText && firstItemBorder) {
        switch (this.warning?.status) {
          case 'success':
            imgElement.src = '../../../assets/icons/common/warning-sucess.svg';

            this.renderer.setStyle(firstItemBorder, 'color', 'var(--green-300)');
            firstItemIcon.insertAdjacentElement('afterend', imgElement);

            if(!isTextActive) {
              this.renderer.setStyle(textElement, 'color', 'var(--green-400)');
              firstItemText.insertAdjacentElement('afterend', textElement);
            }
            break;
          case 'error':
            imgElement.src = '../../../assets/icons/common/warning-error.svg';

            this.renderer.setStyle(firstItemBorder, 'color', 'var(--red-300)');
            firstItemIcon.insertAdjacentElement('afterend', imgElement);

            if(!isTextActive) {
              this.renderer.setStyle(textElement, 'color', 'var(--red-400)');
              firstItemText.insertAdjacentElement('afterend', textElement);
            }
            break;
          case 'info':
            imgElement.src = '../../../assets/icons/common/warning-neutral.svg';

            this.renderer.setStyle(firstItemBorder, 'color', 'var(--blue-300)');
            firstItemIcon.insertAdjacentElement('afterend', imgElement);

            this.renderer.setStyle(textElement, 'color', 'var(--blue-400)');
            firstItemText.insertAdjacentElement('afterend', textElement);
            break;
          case 'alert':
            imgElement.src =
              '../../../assets/icons/common/warning-circle-alert.svg';

            this.renderer.setStyle(firstItemBorder, 'color', 'var(--yellow-400)');
            firstItemIcon.insertAdjacentElement('afterend', imgElement);

            if(!isTextActive) {
              this.renderer.setStyle(textElement, 'color', 'var(--yellow-500)');
              firstItemText.insertAdjacentElement('afterend', textElement);
            }
            break;
          case 'loading':

            const factory =
              this.resolver.resolveComponentFactory(LoadingComponent);

            // Cria uma instância do componente de loading
            const loadingComponentRef = factory.create(this.injector);
            const loadingElement = loadingComponentRef.location.nativeElement;
            loadingElement.setAttribute('class', 'dynamic-loading');
            if(containerIconSelect.length > 0){
              loadingElement.setAttribute(
                'style',
                this.styleWarning ? this.styleWarning :
                `z-index: 2; width: 20px; height: 20px; margin-right:5px; align-self: center; position: relative; top: -5px;`
              );
            } else {
              loadingElement.setAttribute(
                'style',
                this.styleWarning ? this.styleWarning :
                `z-index: 2; width: 20px; height: 20px; margin-right:7px; align-self: center; position:relative; top:-1px`
              );
            }


            loadingComponentRef.instance.size = '23px';
            loadingComponentRef.changeDetectorRef.detectChanges();

            this.renderer.insertBefore(
              firstItemIcon.parentNode,
              loadingComponentRef.location.nativeElement,
              firstItemIcon.nextSibling
            );

            this.renderer.setStyle(firstItemBorder, 'color', 'var(--gray-300)');

            if(!isTextActive) {
              this.renderer.setStyle(
                textElement,
                'color',
                'var(--primary-color-dark)'
              );
              firstItemText.insertAdjacentElement('afterend', textElement);
            }
            break;
          default:
            this.renderer.setStyle(firstItemBorder, 'color', 'var(--gray-300)');
            break
        }
      }
    }
  }

  removeOldElements(nativeElement: HTMLElement): void {
    const oldIcons = nativeElement.getElementsByClassName('dynamic-icon');
    const oldTexts = nativeElement.getElementsByClassName('dynamic-text');
    const oldLoadings = nativeElement.getElementsByClassName('dynamic-loading');

    while (oldIcons?.length > 0) {
      oldIcons[0].parentNode.removeChild(oldIcons[0]);
    }
    while (oldTexts?.length > 0) {
      oldTexts[0].parentNode.removeChild(oldTexts[0]);
    }
    while (oldLoadings?.length > 0) {
      oldLoadings[0].parentNode.removeChild(oldLoadings[0]);
    }
  }


}
